// CDNではなくnpmでインストールしたjQueryを使うため、明示的に読み込む
window.$ = window.jQuery = require('jquery');

//お問い合わせフォームのjQコード
        //以下にjQの動きを追加
        $(document).ready(function() {
        // ページが読み込まれたときに#footer__topを非表示にする
        $('#footer__top').hide();

            function PageTopAnime(){
                console.log('scroll event fired');//イベント発火確認
                let laravelScroll = $(window).scrollTop();
                if(laravelScroll >= 150){//上から150スクロールしたら
                    $('#footer__top').toggle().addClass('animate-UpAnime'); // Tailwindのクラスを追加
                }else{
                    $('#footer__top').hide().removeClass('animate-UpAnime'); //Tailwindのクラスを削除
                }
                }
                $(window).on('scroll', PageTopAnime);//ページトップリンク、下から出現を実行

                $('#footer__top a').on('click',function(){
                    $('body,html').animate({
                    scrollTop: 0//ページトップまでスクロール
                    },1000);//ページトップスクロールの速さ
                    return false;//リンク自体は無効化
                });
                });

            //フォームにおけるjQ、「カウンセリングルーム」のチェックで紹介者項目の表示を変更
                //ページ読み込み時の処理（ページが開かれた時やリロードされた時）
                $(document).ready(function(){
                    //現状確認・ページ読み込み時にセッションストレージから状態を取得（前回保存したチェックボックスの状態）
                    //セッションストレージのデータはブラウザを閉じると消える
                    let checked = sessionStorage.getItem('checked1');
                    
                        //チェックボックスの状態を確認、状態に応じて紹介者の項目を有効化または無効化
                        if(checked === 'true'){
                            //ページが読み込まれた時に前回の状態を復元。prop()関数で選択した要素のプロパティと値を設定。
                            $('#check-input1').prop('checked',true);
                            //disabledはinput要素にしか適用されない
                            $('#referrer_fields').fadeIn(1000);//1秒かけて表示
                            $('#referrer_fields input').prop('disabled',false);
                        }else{
                            //チェックが外れた場合紹介者の項目を無効化
                            $('#check-input1').prop('checked',false);
                            $('#referrer_fields').fadeOut(1000);//1秒かけて非表示
                            $('#referrer_fields input').prop('disabled',true);
                            }

                //チェックボックスの状態が変わった時の処理
                    //jQのchange()関数とis()関数を使用。
                        $('#check-input1').change(function(){
                            if($(this).is(':checked')){
                            //変化した状態をセッションストレージに保存
                            sessionStorage.setItem('checked1','true');
                            //チェックが入った場合、紹介者の項目を有効化
                            $('#referrer_fields').fadeIn(1000);//1秒かけて表示
                            $('#referrer_fields input').prop('disabled',false);
                        }else{
                            sessionStorage.setItem('checked1','false');
                            $('#referrer_fields').fadeOut(1000);//1秒かけて非表示
                            $('#referrer_fields input').prop('disabled',true);
                            }
                        });
                });

                //お問い合わせ内容（テキストエリア）の文字数をリアルタイムカウント（半角・全角文字区別せず、空白含む）
                //ドキュメント（HTMLページ）が全て読み込まれてから関数内のコードを実行
                $(function(){
                    // .ready の打ち消し線は表示上のスタイリングの問題である可能性。動作に影響なしらしい
                    console.log('Document is ready.'); // Document ready 確認のログ
                    //textarea は id="message"

                    let text_max = 200; //テキストエリアの最大文字数

                    //console.log($('#message').length);
                    // テキストエリアを取得
                    let messageElement = $('#message');

                    // 文字数表示領域を取得
                    let wordCountElement = $('#wordCount'); //文字数表示領域


                    // テキストが存在するかどうかを確認
                    if (messageElement.length > 0) {
                        // もしテキストが存在するならテキストエリアの文字数を取得
                        //val() はjQのメソッドで、HTMLのフォーム要素（input、select、textareaなど）の値を取得して設定
                        let text_length = messageElement.val().length; //入力文字数
                        
                        // 残りの文字数を計算
                        let text_remaining = text_max - text_length; //残りの文字数

                        //現状確認、セッションストレージから値を取得
                        let storeValue = sessionStorage.getItem('message');
                        
                        // もしセッションストレージから値が取得できたなら
                        if(storeValue){
                            messageElement.val(storeValue);
                            // 文字列の文字数を再計算
                            //JSの.lengthプロパティは、文字列の文字数や配列の要素数を取得
                            text_length = messageElement.val().length;
                            text_remaining = text_max - text_length;
                        }
                    //文字数表示領域に現在の文字数と最大文字数を表示させる
                    wordCountElement.html(text_length + ' / ' + text_max + '文字');
                }


                    //wordCountElement を条件分岐の外で定義し、条件分岐の内外でアクセス可能に
                    // 文字数表示領域を取得
                    //let wordCountElement = $('#wordCount'); //文字数表示領域

                    //テキストエリアの変更があった場合の処理
                    messageElement.on('input',function(){
                        let text_length = messageElement.val().length;
                        let text_remaining = text_max - text_length;

                        //入力がある場合は文字数を表示
                        if(text_length > 0){
                        // 文字数表示領域を取得
                        wordCountElement.html(text_length + ' / ' + text_max + '文字');
                        //セッションストレージに値を保存
                        sessionStorage.setItem('message', messageElement.val());
                        }else{
                        //入力がない場合、特別なメッセージを表示しない
                        wordCountElement.html('');
                        }
                    });
                });


